import axios from "axios";
import {ActionTree} from "vuex";
import { SystemActionsState, SystemActionsItem } from "@/store/user_management/system_actions/types";
import {RootState} from "@/store/types";

export const actions: ActionTree<SystemActionsState, RootState> = {
    getSystemActions: ({commit}) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({url: '/acapi/system_users/system_actions'})
                .then(resp => {
                    commit('setSystemActions', resp.data.system_actions);
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    saveSystemActions: ({commit}, data: SystemActionsItem) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({
                method: 'put',
                url: `/acapi/users/actions/` + (data.id ?? ''),
                data: {is_allowed: data.is_allowed}
            })
                .then((resp: any) => {
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    getSystemActionsItem: ({commit}, id: number) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({url: `/acapi/users/actions/${id}`})
                .then((resp: any) => {
                    let SystemActionsItem = <SystemActionsItem>resp.data;
                    SystemActionsItem.id = id;
                    resolve(SystemActionsItem)
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    getSystemUsersAction: ({commit}, data: SystemActionsItem) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({url: '/acapi/users/actions', params: data})
                .then(resp => {
                    const response = resp.data.actions;
                    commit('setSystemUsersAction', response);
                    isAccessView(response);
                    resolve(resp?.data ?? [])
                })
                .catch(err => {
                    localStorage.removeItem('isLogSystems');
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
}


const isAccessView = function (response: any): void {
    const isAccessView = response.some((e: any) => e.eng_name == 'Viewing' && e.is_allowed == 1);
    localStorage.setItem('isLogSystems', String(isAccessView));
}

